import { flatten, isEmpty } from 'lodash';

const DEFAULT_LABEL_KEYS = [
  'label',
  'Label',
  'name',
  'Name',
  'display',
  'Display',
  'title',
  'Title',
  'subject',
  'Subject',
];

const getChoiceLabelWithFallback = (
  result: Record<string, string>,
  valueKey: string,
  labelKey?: string | string[]
) => {
  const labelKeys = flatten([labelKey, DEFAULT_LABEL_KEYS]);

  const labelKeyWithFallback = labelKeys.find(
    (key?: string) => key && !isEmpty(result[key])
  );

  if (labelKeyWithFallback) {
    return result[labelKeyWithFallback];
  }

  if (result[valueKey]) {
    return String(result[valueKey]);
  }

  return undefined;
};

export default getChoiceLabelWithFallback;
